import React from 'react'
import '../App.css'

const About = () => {
    return (
        <div className="About-area">
            <h2 className="heading">About ADSiWALL</h2>
            <p>
				You can put your advertistment in ADSiWALL website. You can put any advertistments like shopping site,
				YouTube Channel, Instagram Page etc...
				So by putting your ads in ADSiWALL can promote your brands. And there is only a small amount to get a
				poster area. Your ads will be shown in the poster area given in the site.
			</p>
        </div>
    )
}
export default About
